import TableFields from './TableFields';

export default TableFields;
